<div class="message chat-info {{{o.extra_classes}}}"
     data-isodate="{{{o.isodate}}}"
     {{{o.data}}}>{{{o.message}}}</div>
